"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var WEBMAF_PLAYER_STATES_MAP = {
    buffering: client_lib_js_player_addons_common_player_1.PlayerState.Rebuffering,
    endOfStream: client_lib_js_player_addons_common_player_1.PlayerState.Finished,
    notReady: client_lib_js_player_addons_common_player_1.PlayerState.Loading,
    opening: client_lib_js_player_addons_common_player_1.PlayerState.Loading,
    paused: client_lib_js_player_addons_common_player_1.PlayerState.Paused,
    DisplayingVideo: client_lib_js_player_addons_common_player_1.PlayerState.Playing,
    stopped: client_lib_js_player_addons_common_player_1.PlayerState.Stopped,
    unknown: client_lib_js_player_addons_common_player_1.PlayerState.Stopped,
};
function getPlayerState(webMafPlayerState) {
    if (WEBMAF_PLAYER_STATES_MAP[webMafPlayerState] !== undefined) {
        return WEBMAF_PLAYER_STATES_MAP[webMafPlayerState];
    }
    return null;
}
exports.getPlayerState = getPlayerState;
